module.exports = __webpack_public_path__ + "img/the_fintech_20.71b1944e.png";